<template>
    <Path>
        <template v-slot:path>
            <li>
                <router-link :to="{ name: 'dashboard' }">الصفحة الرئيسية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#">المقترحات والاستفسارات </a> </li>
        </template>
    </Path>

    <section>
        <div class="popup" modal="popup" id="popup">
            <img src="@/assets/images/tick.png">
            <h2>شكرا</h2>
            <button @click="closePopup">إغلاق </button>
        </div>

        <form name="Form">
            <div class="py-4 ">
                <div class="container">
                    <div @click="closePopup">
                        <div class="row">
                            <div class="col-12 mb-2">
                                <h2 class="blueFont ">تواصل معنا</h2>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">الإسم</label>
                                <div class="input-group mb-3">
                                    <div class="col-md-12">
                                        <input v-model="form.name" type="text" class="form-control " id="basic-ur4l"
                                            aria-describedby="basic-addon3" @blur="v$.form.name.$touch()">
                                        <p class="data--required" v-for="error of v$.form.name.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">البريد الإلكترونى</label>
                                <div class="input-group mb-3">
                                    <div class="col-md-12">
                                        <input v-model="form.email" type="text" class="form-control " id="basic-ur4l"
                                            aria-describedby="basic-addon3" @blur="v$.form.email.$touch()">
                                        <p class="data--required" v-for="error of v$.form.email.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">رقم المحمول</label>
                                <div class="input-group mb-3">
                                    <div class="col-md-12">
                                        <input v-model="form.mobile" type="text" class="form-control " id="basic-ur4l"
                                            aria-describedby="basic-addon3" @blur="v$.form.mobile.$touch()">
                                        <p class="data--required" v-for="error of v$.form.mobile.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">نوع المقترح</label>
                                <div class="input-group mb-3">
                                    <div class="col-md-12">
                                        <select v-model="form.typeId" class="form-select" id="basic-url1"
                                            aria-describedby="basic-addon3" @blur="v$.form.typeId.$touch()">
                                            <option v-for="contactUsType in contactUsTypes" :key="contactUsType.Id"
                                                :value="contactUsType.Id">
                                                {{ contactUsType.Name }}</option>
                                        </select>
                                        <p class="data--required" v-for="error of v$.form.typeId.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">الرسالة</label>
                                <div class="input-group mb-3">
                                    <div class="col-md-12">
                                        <textarea v-model="form.message" rows="4" type="text" class="form-control"
                                            id="basic-ur4l" aria-describedby="basic-addon3"
                                            @blur="v$.form.message.$touch()"></textarea>
                                        <p class="data--required" v-for="error of v$.form.message.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row my-5 justify-content-center">
                        <div class="col-12 col-sm-4 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="ContactUs()" type="button" class="btn1 btn-light mx-3 align-self-center">
                                    إرسال
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </form>
    </section>

</template>

<script>
import Path from '@/components/Path.vue';
import useVuelidate from "@vuelidate/core";
import validations from "@/shared/validations.js";
import sharedData from '@/shared/sharedData';
import { debugError, debugLog } from "@/plugins/debug";

export default {
    name: 'ComplainsComp',
    data() {
        return {
            v$: useVuelidate(),
            form: {
                name: '',
                mobile: '',
                email: '',
                typeId: Number,
                message: '',
            },
            contactUsTypes: sharedData.contactUs_types,
        }
    },
    components: { Path },
    // validations
    validations() {
        return {
            ...validations.Complains
        }
    },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
    methods: {
        closePopup() {
            let element = document.querySelector('.popup');
            element.classList.remove("open-popup");
        },
        openPopUp() {
            let element = document.querySelector('.popup');
            element.classList.add("open-popup");
        },
        async ContactUs(){ 
            const data = {
                            "email": this.form.email,
                            "mobile": this.form.mobile,
                            "name": this.form.name,
                            "message": this.form.message,
                            "contactTypeId": parseInt(this.form.typeId)
                            }
            await this.$api.requests.ContactUs(data)   
            .then(res => {      
                debugLog('====Contact Us Response========',res);  
                this.openPopUp();
            }).catch(err => {
                debugError(`${err}`);     
            });
        },
        submit() { 
            this.v$.$validate();
            if (!this.v$.$error) {
                this.ContactUs();
            }else{this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');}
        },
    }
}

</script>

<style>
.popup {
    width: 400px;
    background: #fff;
    border-radius: 6px;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.1);
    text-align: center;
    padding: 0 30px 30px;
    color: #333;
    visibility: hidden;
    transition: transform 0.4s, top 0.4s;
    z-index: 99 !important;
    border-color: #333;
    mask-border-width: 5px;
    box-shadow: 0 30px 30px 24px rgba(0, 0, 0, 0.5);
}

.open-popup {
    visibility: visible;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
}

.popup img {
    width: 100px;
    margin-top: -50px;
    border-radius: 50%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.popup h2 {
    font-size: 38px;
    font-weight: 500;
    margin: 30px;
}

.popup button {
    width: 100%;
    margin-top: 35px;
    padding: 10px 0;
    /* background: #6fd649;*/
    background: #17479e;
    color: #fff;
    border: 0;
    outline: none;
    font-size: 30px;
    border-radius: 4px;
    cursor: pointer;
}
</style>
